<template>
  <div
    class="simple-carousel-item flex"
    @click="handleItemClick"
  >
    <slot />
  </div>
</template>

<script>

export default defineComponent({
  name: 'SimpleCarouselItem',
  emits: ['click'],
  setup(_props, { emit }) {

    const handleItemClick = () => {

      emit('click');
    
    };

    return {
      handleItemClick,
    };
  
  },
});

</script>
